// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"ccd60962","77":"08a70bc5","357":"577ad201","394":"bfa56146","397":"5a0c1b38","780":"0a52f7b2","868":"885d961b","913":"02870f97","915":"42e17acf","919":"361746ab"}[chunkId] + ".chunk.js";
};